var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C1.21332 1 2.30989 1.72308 2.78784 2.83829L4.32471 6.42432C4.75594 7.43052 4.75594 8.56948 4.32471 9.57568L2.78784 13.1617C2.30989 14.2769 1.21332 15 0 15V1Z",
    fill: "#EB612C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4.45957 0.80304C4.35079 0.549225 4.05686 0.43165 3.80304 0.540427C3.54923 0.649205 3.43165 0.943145 3.54043 1.19696L4.45957 0.80304ZM6.32471 6.42432L6.78428 6.22736L6.32471 6.42432ZM6.32471 9.57568L5.86514 9.37872H5.86514L6.32471 9.57568ZM3.54043 14.803C3.43165 15.0569 3.54923 15.3508 3.80304 15.4596C4.05686 15.5684 4.35079 15.4508 4.45957 15.197L3.54043 14.803ZM3.54043 1.19696L5.86514 6.62128L6.78428 6.22736L4.45957 0.80304L3.54043 1.19696ZM5.86514 9.37872L3.54043 14.803L4.45957 15.197L6.78428 9.77264L5.86514 9.37872ZM5.86514 6.62128C6.24246 7.5017 6.24246 8.4983 5.86514 9.37872L6.78428 9.77264C7.26941 8.64067 7.26941 7.35933 6.78428 6.22736L5.86514 6.62128Z",
    fill: "#EB612C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailMenu);
export default __webpack_public_path__ + "static/media/detail_menu.d78ff48e3206ebed931f661303b035b1.svg";
export { ForwardRef as ReactComponent };